export const trimAndLowerString = (str: string = '') => str.trim().toLocaleLowerCase();
